import React, { useEffect, useRef, useState } from 'react';
import AOS from 'aos'; // AOS 스크립트 파일을 임포트
import { Swiper, SwiperSlide } from 'swiper/react';

import heroImage from '../../assets/imgs/corocationHero.webp';
import corocationIntroImage from '../../assets/imgs/corocationIntroImg.jpg';
import hostingIntroBackground from '../../assets/imgs/hostingIntroBackground.png';
import productBannerForCorocation from '../../assets/imgs/productBannerForCorocation.png';
import portfolioImg1 from '../../assets/imgs/coroService1.jpg';
import portfolioImg2 from '../../assets/imgs/coroService2.jpg';
import portfolioImg3 from '../../assets/imgs/coroService3.jpg';
import bannerImg from '../../assets/imgs/bannerImg.jpg';
import BlackArrowBtn from '../../components/global/BlackArrowBtn';
import { ReactComponent as Rack1 } from '../../assets/imgs/rack1.svg';
import { ReactComponent as Rack2 } from '../../assets/imgs/rack2.svg';
import { ReactComponent as Rack3 } from '../../assets/imgs/rack3.svg';
import { ReactComponent as Single1 } from '../../assets/imgs/single1.svg';
import { ReactComponent as Single2 } from '../../assets/imgs/single2.svg';
import { ReactComponent as Single3 } from '../../assets/imgs/single3.svg';
import { Link } from 'react-router-dom';
import useSwiperProgress from '../hook/useSwiperProgress';

const productData = [
  {
    cateCode: 'rack',
    caption: '1/4',
    name: '1/4 Rack (쿼터 랙)',
    description: '소규모 장비 운영에 \t 적합한 경제적인 선택',
    char: [
      '1~2대 정도의 서버 또는 네트워크 장비에 최적화',
      '스타트업, 테스트 서버, 개인 운영 목적 고객에게 추천',
      '전용 공간 제공 + 출입 통제 및 기본 보안 포함',
    ],
  },
  {
    cateCode: 'rack',
    caption: '1/2',
    name: '1/2 Rack (하프 랙)',
    description: '확장성을 고려한  \t 중소규모 비즈니스에 적합',
    char: [
      '최대 4~6대 장비 수용 가능',
      '스타트업, 테스트 서버, 개인 운영 목적 고객에게 추천',
      '고정 IP 사용, 전력·트래픽 옵션 유연',
    ],
  },
  {
    cateCode: 'rack',
    caption: 'full',
    name: 'Full Rack (풀 랙)',
    description: '대규모 시스템 및  \t  전용 서버실급 운영 환경',
    char: [
      '42U 전 공간 독립 사용 (고객 전용 랙 제공)',
      '금융, 게임, 보안 등 고성능·고가용성 환경 필요 고객 대상',
      '전력·쿨링·네트워크 구성도 커스터마이징 가능',
    ],
  },
  {
    cateCode: 'single',
    caption: '1U',
    name: '1U',
    description: '가장 슬림한 단위,   \t  소규모 서버 1대 운영에 적합',
    char: [
      '높이 약 4.45cm의 1U 서버 한 대 수용',
      '개인용 서버, 테스트 서버 또는 네트워크 장비에 적합',
      '합리적인 비용으로 클라우드보다 직접적인 운영이 가능',
    ],
  },
  {
    cateCode: 'single',
    caption: '2U',
    name: '2U',
    description: '확장 가능한 기본 서버 운영에   \t  가장 많이 선택되는 구성',
    char: [
      '높이 약 8.9cm, 표준 19인치 랙 규격에 적합',
      ' 웹 서버, 백업 서버, NAS 등 다양한 용도로 활용 가능',
      '스타트업 및 중소기업에 추천되는 베스트셀러 사이즈',
    ],
  },
  {
    cateCode: 'single',
    caption: '4U',
    name: '4U',
    description: '다중 서비스용 서버 또는    \t  고사양 장비 운용에 최적',
    char: [
      '고성능 GPU 서버, 스토리지 서버 등 장비 크기가 큰 경우에 추천',
      '시스템 확장성 및 열 관리까지 고려한 인프라 구성 가능',
      '물리적 공간이 넉넉해 다양한 연결 장비와도 안정적인 연동 가능',
    ],
  },
];
const qnaData = [
  {
    q: '코로케이션이란 무엇인가요?',
    a: '고객이 보유한 서버 장비를 전문 IDC 센터에 설치하여 전력, 네트워크, 냉각, 보안을 통합 제공받는 서비스입니다.',
  },
  {
    q: '1U, 2U, 랙 단위는 어떻게 구분되나요?',
    a: 'U는 서버의 높이 단위를 뜻하며, 1U는 약 4.45cm입니다. 장비 수나 규모에 따라 1U/2U/Full Rack 중 선택하실 수 있습니다.',
  },
  {
    q: '트래픽이나 IP는 추가 구매 가능한가요?',
    a: '네, 가능합니다. 트래픽 확장, 고정 IP 추가, 포트 대역폭 변경 등 유연하게 조정 가능합니다.',
  },
  {
    q: '서버에 문제가 생기면 어떻게 대응하나요?',
    a: '24시간 NOC 모니터링과 원격 핸즈 서비스를 통해 즉각 대응이 가능하며, 장애 발생 시 기술지원팀이 빠르게 조치합니다.',
  },
];
function CorocationMain({ firstSectionRef }) {
  const [activeProductTab, setActiveProductTab] = useState('rack');
  const productSwiper = useRef(null);
  const [productActiveIndex, setProductActiveIndex] = useState('rack');
  const [perGroup, setPerGroup] = useState(3); // Swiper의 slidesPerGroup 값
  const [activeFaqTab, setActiveFaqTab] = useState(0);
  const [portfolioActiveIndex, setPortfolioActiveIndex] = useState(1);
  const {
    progressPercent,
    tooltipPercent,
    tooltipVisible,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useSwiperProgress(productSwiper, productActiveIndex, perGroup);
  useEffect(() => {
    if (productSwiper.current) {
      setPerGroup(productSwiper.current.params.slidesPerGroup || 1);
    }
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // 애니메이션 지속 시간 (ms)
      easing: 'ease-out', // 애니메이션 이징 함수
      once: false, // 스크롤 후 한 번만 애니메이션 실행
    });
  }, []);
  return (
    <div className="corocationMainPageWrapper">
      <div
        data-aos="fade"
        data-aos-delay="0"
        data-aos-offset="0"
        ref={firstSectionRef}
        className="subHeroSection"
      >
        <div className="heroItem flex-col align-center justify-center">
          <div className="subHeroImage">
            <img src={heroImage} alt="" />
          </div>
          <div className="grid flex-col justify-center align-center">
            <div className="flex-col gap-48 justify-center align-center">
              <div className="mainText">
                <span>코로케이션</span>
              </div>
              <div className="description">
                <span>
                  <strong>전문 IDC 환경에서</strong> 고성능 장비를 안정적으로
                  운영하고,
                  <br />
                  24시간 모니터링, 이중 전력, 냉각 시스템, 보안 체계를 통해
                  <br /> 고객 장비를 <strong>
                    안전하고 합리적인 비용으로
                  </strong>{' '}
                  으로 관리할 수 있습니다.
                </span>
              </div>
              <div className="divide"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="serviceIntroSection py-128 flex-col align-center justify-center"
      >
        <div className="grid tab:flex-col flex-row gap-16 justify-between">
          <div className="textWrap flex-col gap-32">
            <div className="background tab:display-none">
              <img src={hostingIntroBackground} alt="" />
            </div>
            <div className="titleWrap flex-col gap-24">
              <div className="accent flex-row gap-8">
                <span>OPTIMAL COLLOCATION</span>
              </div>
              <div className="title">
                <span>최적의 코로케이션 환경 제공</span>
              </div>
            </div>
            <div className="description">
              <span>
                이중 전원, 고밀도 냉각, 스마트 모니터링 시스템을 갖춘
                <br />
                고신뢰·고효율의 인프라 환경을 제공합니다.
                <br />
                <br />
                24시간 NOC 운영과 실시간 대응 체계를 통해
                <br /> 고객 장비를 안전하고 안정적으로 운영할 수 있습니다.
              </span>
            </div>
          </div>
          <div className="imgWrap ">
            <div className="layerOne">
              <img src={corocationIntroImage} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="ourStrongSection py-96 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-48">
          <div className="titleWrap flex-col gap-24">
            <div className="accent flex-row gap-8">
              <span>FEATURES & BENEFITS</span>
            </div>
            <div className="title">
              <span>디엔에이클라우드만의 장점</span>
            </div>
          </div>
          <div className="cardWrap tab:flex-col flex-row gap-16">
            <div className="card flex-full flex-col align-end gap-56 py-40 px-24">
              <div className="textWrap  flex-col gap-24">
                <div className="numberWrap">
                  <span>01</span>
                </div>
                <div className="titleWrap">
                  <span>
                    24/7 운영 및
                    <br />
                    무중단 대응
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    24시간 상시 운영 및 실시간 대응 전담 NOC와 연계된 모니터링
                    시스템으로 장애 발생 시 실시간 알림 및 신속한 기술 대응이
                    가능합니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="118"
                  height="110"
                  viewBox="0 0 118 110"
                  fill="none"
                >
                  <path
                    d="M97.485 55.1885L65.9465 73.4088V36.9702L97.485 18.7498V55.1885Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M65.9465 36.9698L34.4082 18.7495L65.9445 0.529076L97.4829 18.7495L65.9465 36.9698Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M65.9465 73.4088L34.4082 55.1885V18.7498L65.9465 36.9702V73.4088Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M54.5852 53.722L45.7634 48.6271V38.4351L54.5852 43.5301V53.722Z"
                    fill="white"
                  />
                  <path
                    d="M54.5852 53.722L45.7634 48.6271V44.4502C46.0556 44.1229 46.3395 43.7956 46.6234 43.4642C49.2856 43.773 51.9416 44.1127 54.5852 44.4812V53.722Z"
                    fill="white"
                  />
                  <path
                    d="M63.0767 79.3054L31.5383 97.5258V61.087L63.0767 42.8667V79.3054Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M31.5384 61.0861L0 42.8657L31.5384 24.6453L63.0768 42.8677L31.5384 61.0861Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M31.5381 48.7639L21.3298 42.8682L31.5381 36.9684L41.7465 42.8682L31.5381 48.7639Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M31.5384 97.5249L0 79.3045V42.8658L31.5384 61.0862V97.5249Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M20.1807 77.839L11.3569 72.742V62.5521L20.1807 67.6491V77.839Z"
                    fill="white"
                  />
                  <path
                    d="M117.666 91.6283L86.1274 109.849V73.41L117.666 55.1896V91.6283Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M86.1274 73.4098L54.5891 55.1894L86.1254 36.969L117.664 55.1894L86.1274 73.4098Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M86.1274 109.849L54.5891 91.6283V55.1896L86.1274 73.41V109.849Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M74.7661 90.1619L65.9443 85.0669V74.8749L74.7661 79.9699V90.1619Z"
                    fill="white"
                  />
                  <path
                    d="M74.7661 90.1619L65.9443 85.0669V80.8901C66.2365 80.5628 66.5204 80.2354 66.8043 79.904C69.4665 80.2128 72.1225 80.5525 74.7661 80.921V90.1619Z"
                    fill="white"
                  />
                  <circle
                    cx="29.4299"
                    cy="17.6501"
                    r="14.8886"
                    fill="#FC6A16"
                  />
                  <path
                    d="M22.8176 13.621H25.7563C26.146 13.621 26.5197 13.7758 26.7953 14.0513C27.0709 14.3269 27.2257 14.7006 27.2257 15.0903V16.5597C27.2257 16.9494 27.0709 17.3231 26.7953 17.5986C26.5197 17.8742 26.146 18.029 25.7563 18.029H24.287C23.8973 18.029 23.5235 18.1838 23.248 18.4594C22.9724 18.7349 22.8176 19.1087 22.8176 19.4984V20.9677C22.8176 21.3574 22.9724 21.7311 23.248 22.0067C23.5235 22.2822 23.8973 22.437 24.287 22.437H27.2257"
                    stroke="white"
                    stroke-width="2.93869"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.6335 13.621V16.5597C31.6335 16.9494 31.7883 17.3231 32.0639 17.5986C32.3395 17.8742 32.7132 18.029 33.1029 18.029H34.5722"
                    stroke="white"
                    stroke-width="2.93869"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M36.0417 13.621V22.437"
                    stroke="white"
                    stroke-width="2.93869"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div className="card flex-full flex-col align-end gap-56 py-40 px-24">
              <div className="textWrap flex-col gap-24">
                <div className="numberWrap">
                  <span>02</span>
                </div>
                <div className="titleWrap">
                  <span>
                    고신뢰 이중화
                    <br />
                    인프라 제공
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    전력, 네트워크, 냉각 모두 이중화된 구조로 설계되어 고가용성
                    환경에서 기업 자산을 안정적으로 운영할 수 있습니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="197"
                  height="125"
                  viewBox="0 0 197 125"
                  fill="none"
                >
                  <g clip-path="url(#clip0_244_81)">
                    <path
                      d="M31.3234 78.1311L107.635 122.181L193.501 72.9304L117.189 28.8791L31.3234 78.1311ZM107.632 123.911L28.3179 78.1282L117.192 27.149L196.506 72.9334L107.632 123.911Z"
                      fill="#1681FC"
                    />
                    <path
                      d="M159.612 71.91L151.905 67.4753L180.325 51.1265C181.668 50.3561 181.668 49.0991 180.325 48.3258L151.29 31.6265C149.949 30.8531 147.764 30.8531 146.422 31.6265L118.001 47.9723L110.292 43.5391L138.714 27.1903C144.306 23.9755 153.405 23.9741 158.999 27.1903L188.032 43.8925C193.626 47.1088 193.626 52.3435 188.034 55.5612L159.612 71.91Z"
                      fill="#1681FC"
                    />
                    <path
                      d="M172.052 73.8599C172.052 69.7549 169.545 64.9845 166.455 63.2071L114.961 33.5881C113.576 32.7926 112.313 32.7349 111.337 33.2791L111.334 33.2776L49.8511 68.8721L109.306 113.508L169.879 78.4824C170.066 78.3966 170.247 78.299 170.413 78.1733V78.1718C171.426 77.4088 172.052 75.9123 172.052 73.8599Z"
                      fill="#D9EFFB"
                    />
                    <path
                      d="M109.306 113.507L169.879 78.4815C170.066 78.3957 170.247 78.2982 170.413 78.1725V78.171C171.425 77.408 172.052 75.9115 172.052 73.859C172.052 71.8997 171.476 69.791 170.542 67.9263L101.496 107.644L109.306 113.507Z"
                      fill="#4067B1"
                    />
                    <path
                      d="M105.433 113.351L53.9403 83.7308C50.8486 81.9534 48.3433 77.183 48.3433 73.078C48.3433 68.9716 50.8486 67.0847 53.9403 68.8622L105.433 98.4826C108.524 100.26 111.028 105.03 111.028 109.135C111.028 113.242 108.524 115.129 105.433 113.351Z"
                      fill="#263C7A"
                    />
                    <path
                      d="M106.054 98.2017L54.5601 68.5828C53.1397 67.765 51.8439 67.731 50.8569 68.321C51.7415 68.0534 52.8013 68.2086 53.9412 68.8622L105.433 98.4812C108.525 100.26 111.029 105.031 111.029 109.135C111.029 111.354 110.294 112.917 109.135 113.612C110.651 113.152 111.649 111.447 111.649 108.856V108.855C111.649 104.75 109.144 99.9806 106.054 98.2017Z"
                      fill="white"
                    />
                    <path
                      d="M97.7234 103.36L91.5326 99.8025C90.9167 99.4491 90.4165 98.4968 90.4165 97.6806C90.4165 96.8614 90.9167 96.4858 91.5326 96.8392L97.7234 100.397C98.3393 100.75 98.838 101.703 98.838 102.52C98.838 103.338 98.3393 103.714 97.7234 103.36Z"
                      fill="#EE1696"
                    />
                    <path
                      d="M105.633 61.7677C107.251 60.8154 107.235 59.2968 105.596 58.377C103.959 57.4572 101.32 57.4868 99.7022 58.4391C98.0829 59.3929 98.0992 60.9101 99.7363 61.8299C101.375 62.7496 104.014 62.723 105.633 61.7677Z"
                      fill="#5F92D3"
                    />
                    <path
                      d="M114.616 66.813C116.234 65.8592 116.219 64.3406 114.58 63.4223C112.943 62.501 110.303 62.5291 108.685 63.4829C107.067 64.4352 107.082 65.9538 108.72 66.8736C110.358 67.7919 112.998 67.7653 114.616 66.813Z"
                      fill="white"
                    />
                    <path
                      d="M123.599 71.855C125.217 70.9012 125.201 69.3841 123.564 68.4643C121.925 67.543 119.286 67.5712 117.668 68.5249C116.049 69.4787 116.065 70.9974 117.704 71.9157C119.341 72.8369 121.98 72.8088 123.599 71.855Z"
                      fill="white"
                    />
                    <path
                      d="M70.9039 102.71C68.9536 103.832 65.7878 103.832 63.836 102.71C61.8828 101.586 61.8828 99.7674 63.836 98.6436C65.7878 97.5212 68.9522 97.5212 70.9039 98.6436C72.8572 99.7674 72.8572 101.586 70.9039 102.71Z"
                      fill="#1681FC"
                    />
                    <path
                      d="M26.7081 125L26.3296 124.78L-41.3352 85.3354L-109 45.891L-28.9289 0.000123524L-28.178 1.29697L-106.006 45.9029L-39.6472 84.585L26.7111 123.267L66.993 100.029L67.747 101.324L26.7081 125Z"
                      fill="url(#paint0_linear_244_81)"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_244_81"
                      x1="-1.5113"
                      y1="89.1629"
                      x2="67.6831"
                      y2="108.162"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1681FC" stop-opacity="0" />
                      <stop offset="1" stop-color="#1681FC" />
                    </linearGradient>
                    <clipPath id="clip0_244_81">
                      <rect width="197" height="125" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div className="card flex-full flex-col align-end gap-56 py-40 px-24">
              <div className="textWrap flex-col gap-24">
                <div className="numberWrap">
                  <span>03</span>
                </div>
                <div className="titleWrap">
                  <span>
                    합리적인 비용의
                    <br />
                    전용 공간 확보
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    자체 장비를 안정적인 공간에 배치하고, 높은 효율성과 비용
                    절감이 가능한 공간 최적화 솔루션을 제공합니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="98"
                  height="123"
                  viewBox="0 0 98 123"
                  fill="none"
                >
                  <path
                    d="M93.2142 39.0996L27.3786 1.08773C26.2704 0.448502 25.2647 0.438622 24.5083 0.927299V0.918678L1.74658 14.0895L23.1286 26.8629V62.9941C23.1286 66.1236 25.0315 69.7578 27.3786 71.114L72.3319 97.0669L73.2525 122.503L95.8414 109.423L96.1364 109.251L96.182 109.225L96.1796 109.223C96.9718 108.651 97.4629 107.501 97.4629 105.911V47.2183C97.4629 44.0888 95.5613 40.4533 93.2142 39.0996Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M54.8379 86.9676L72.3315 97.0669L73.2521 122.503L95.841 109.423L96.136 109.251L96.1817 109.225L96.1792 109.223C96.9714 108.651 97.4626 107.501 97.4626 105.911V47.2183C97.4626 45.8806 97.1133 44.4528 96.5321 43.1472L54.8379 67.2207V86.9676Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M70.3492 122.356L4.51243 84.3441C2.16654 82.9904 0.263672 79.3549 0.263672 76.2266V17.5324C0.263672 14.4029 2.16654 12.9652 4.51243 14.3202L70.3492 52.3308C72.6951 53.6846 74.598 57.32 74.598 60.4483V119.143C74.598 122.272 72.6951 123.71 70.3492 122.356Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M71.2624 51.8105L5.42685 13.7998C4.15827 13.0668 3.0316 13.173 2.25293 13.8998C2.90943 13.7258 3.68071 13.8393 4.51368 14.3206L70.3505 52.3312C72.6964 53.6849 74.5993 57.3204 74.5993 60.4487V119.143C74.5993 120.581 74.1846 121.639 73.5232 122.255C74.7152 121.942 75.5112 120.641 75.5112 118.622V59.9292C75.5112 56.7997 73.6096 53.1642 71.2624 51.8105Z"
                    fill="white"
                  />
                  <path
                    d="M73.3824 50.5644L7.54686 12.5538C6.27704 11.8208 5.14049 11.9121 4.36182 12.6389C5.08249 12.3057 5.98579 12.3748 6.97178 12.9437L72.8074 50.9543C75.1545 52.3105 77.0561 55.9448 77.0561 59.0743V117.768C77.0561 119.204 76.6526 120.278 75.9924 120.896C76.9895 120.434 77.6312 119.193 77.6312 117.377V58.6831C77.6312 55.5548 75.7295 51.9193 73.3824 50.5644Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M68.4298 119.207L6.43337 83.413C4.22322 82.1383 2.43262 78.7139 2.43262 75.7682V20.496C2.43262 17.5503 4.22322 16.1954 6.43337 17.4714L68.4298 53.2657C70.64 54.5404 72.4305 57.9648 72.4305 60.9105V116.183C72.4305 119.128 70.64 120.483 68.4298 119.207Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M11.015 29.5672C11.015 30.415 10.419 30.7593 9.68475 30.3348C8.9505 29.9115 8.35449 28.8799 8.35449 28.0309C8.35449 27.1831 8.9505 26.8388 9.68475 27.2633C10.419 27.6878 11.015 28.7194 11.015 29.5672Z"
                    fill="#EE1696"
                  />
                  <path
                    d="M27.8764 75.9194C27.6901 75.9194 27.4852 75.8602 27.2693 75.7356L11.217 66.4692C10.3705 65.9805 9.68555 64.6712 9.68555 63.5421V45.5561C9.68555 44.717 10.0656 44.2147 10.6086 44.2147C10.7949 44.2147 11.001 44.2727 11.217 44.3986L27.2693 53.6661C28.1146 54.1536 28.8007 55.4641 28.8007 56.592V74.578C28.8007 75.4184 28.4206 75.9194 27.8764 75.9194Z"
                    fill="#364C9B"
                  />
                  <path
                    d="M14.8612 63.4694C15.1463 63.6347 15.2894 63.4385 15.2894 62.882V60.4226L15.282 60.2177L15.2635 60.0141L15.219 59.808L15.1426 59.6229L15.0265 59.4538L14.8612 59.3243L14.6711 59.2662L14.5453 59.3255L14.4749 59.4847L14.4428 59.692L14.4354 59.9302V62.3896C14.4354 62.9461 14.5774 63.3052 14.8612 63.4694ZM15.8089 64.3998C15.5905 64.5738 15.2746 64.5417 14.8612 64.3036C14.449 64.0654 14.1343 63.7347 13.9147 63.3065C13.6962 62.8783 13.5864 62.4143 13.5864 61.9133V59.423C13.5864 58.9047 13.6938 58.5592 13.9048 58.3839C14.1158 58.2087 14.4354 58.2445 14.8612 58.4901C15.2845 58.7344 15.6016 59.0688 15.8163 59.4896C16.0298 59.9117 16.1384 60.3806 16.1384 60.8952V63.3879C16.1384 63.8889 16.0286 64.2258 15.8089 64.3998Z"
                    fill="white"
                  />
                  <path
                    d="M17.716 65.874V61.3044L16.9263 61.0909V60.3665C17.4298 60.4628 17.7592 60.4492 17.9135 60.3221L18.5576 60.6936V66.359L17.716 65.874Z"
                    fill="white"
                  />
                  <path
                    d="M19.8096 66.515V65.5944L20.6092 66.0572V66.9753L19.8096 66.515ZM19.8096 64.2012V63.2782L20.6092 63.7385V64.6615L19.8096 64.2012Z"
                    fill="white"
                  />
                  <path
                    d="M22.376 68.6411C21.9379 68.3894 21.6145 68.0623 21.4048 67.6613C21.1962 67.2602 21.0913 66.8036 21.0913 66.294V66.0928L21.9317 66.5765V66.7345C21.9354 67.0245 21.9687 67.254 22.0304 67.428C22.0921 67.5996 22.2093 67.7366 22.3821 67.8353L22.5758 67.9031L22.7042 67.8612L22.777 67.7131L22.8103 67.4885C22.8164 67.4095 22.8202 67.312 22.8202 67.1923C22.8202 66.8925 22.777 66.6383 22.6931 66.4322C22.6067 66.2249 22.4599 66.0546 22.2476 65.9188L22.1822 65.8806L22.1205 65.8423V65.0303L22.2328 65.0896C22.45 65.2093 22.603 65.2327 22.6893 65.1574C22.7757 65.0834 22.8202 64.9044 22.8202 64.6206C22.8202 64.3689 22.7868 64.1616 22.7202 63.9987C22.6536 63.8345 22.5376 63.7037 22.3697 63.6075L22.1834 63.5408L22.0588 63.5791L21.9822 63.7111L21.9452 63.9086L21.9317 64.164V64.3553L21.0913 63.8703V63.6075C21.0913 63.1237 21.2024 62.8152 21.4233 62.677C21.6454 62.54 21.9613 62.5882 22.3697 62.8239C22.7831 63.0633 23.1003 63.3767 23.32 63.7642C23.5433 64.1529 23.6544 64.5861 23.6544 65.0661C23.6544 65.3869 23.5939 65.6214 23.473 65.7646C23.3533 65.9102 23.1941 65.9571 22.9942 65.9089C23.2052 66.115 23.3668 66.3655 23.4828 66.6617C23.5976 66.9566 23.6544 67.2886 23.6544 67.66C23.6544 68.2018 23.5519 68.5633 23.3471 68.7485C23.141 68.9323 22.8177 68.8965 22.376 68.6411Z"
                    fill="white"
                  />
                  <path
                    d="M24.4058 69.7366L25.3621 65.3669L24.0664 64.6191V63.8737L26.1877 65.0979V65.6693L25.2202 70.2068L24.4058 69.7366Z"
                    fill="white"
                  />
                  <path
                    d="M66.5073 56.3782L36.1674 38.8969C35.5159 38.5206 34.926 38.5144 34.4792 38.8032V38.7982L26.9937 43.1149L39.5721 50.6301V71.885C39.5721 73.7262 40.6926 75.8648 42.0735 76.662L60.1274 87.0501L60.6691 102.013L68.0523 97.7503L68.2263 97.6491L68.2534 97.6331L68.2522 97.6319C68.7175 97.2962 69.0075 96.6187 69.0075 95.6833V61.1539C69.0075 59.314 67.8882 57.1742 66.5073 56.3782Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M42.0734 76.662L60.1273 87.0501L60.669 102.013L68.0522 97.7503L68.2262 97.6491L68.2533 97.6331L68.2521 97.6319C68.7173 97.2962 69.0074 96.6187 69.0074 95.6833V61.1539C69.0074 60.3691 68.8025 59.5312 68.4619 58.7648L40.4556 74.9356C40.8924 75.681 41.4563 76.3054 42.0734 76.662Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M58.9594 101.928L28.6208 84.4463C27.2399 83.6491 26.1206 81.5106 26.1206 79.6706V45.1387C26.1206 43.2988 27.2399 42.4523 28.6208 43.2494L58.9594 60.7307C60.3403 61.5267 61.4596 63.6665 61.4596 65.5064V100.037C61.4596 101.878 60.3403 102.724 58.9594 101.928Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M60.236 59.9326L29.8973 42.4526C29.0619 41.9701 28.3277 42.0972 27.8735 42.6735C28.1746 42.6759 28.5054 42.7722 28.8533 42.9721L59.192 60.4534C60.5729 61.2493 61.6921 63.3891 61.6921 65.2291V99.761C61.6921 100.488 61.512 101.052 61.2158 101.428C62.108 101.437 62.7361 100.617 62.7361 99.2402V64.7096C62.7361 62.8684 61.6169 60.731 60.236 59.9326Z"
                    fill="white"
                  />
                  <path
                    d="M57.4557 99.016L30.1256 83.2698C28.8817 82.5528 27.8735 80.6253 27.8735 78.9667V47.8605C27.8735 46.2032 28.8817 45.4406 30.1256 46.1588L57.4557 61.9063C58.6996 62.6232 59.7078 64.5508 59.7078 66.2093V97.3155C59.7078 98.9728 58.6996 99.7342 57.4557 99.016Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M53.0561 77.9375C53.0561 83.8473 48.9085 86.2425 43.7898 83.287C38.6735 80.3328 34.5234 73.1482 34.5234 67.2384C34.5234 61.3287 38.6735 58.9334 43.7898 61.8877C48.9085 64.8432 53.0561 72.0277 53.0561 77.9375Z"
                    fill="#21305F"
                  />
                  <path
                    d="M50.741 74.7403C50.741 77.9981 48.4543 79.3185 45.6321 77.6896C42.8099 76.0607 40.5244 72.0994 40.5244 68.8416C40.5244 65.5838 42.8099 64.2634 45.6321 65.8923C48.4543 67.5212 50.741 71.4824 50.741 74.7403Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M47.9251 73.1156C47.9251 74.5792 46.8984 75.1715 45.631 74.441C44.3637 73.7092 43.3369 71.9297 43.3369 70.4674C43.3369 69.0038 44.3637 68.4115 45.631 69.1432C46.8984 69.8738 47.9251 71.6533 47.9251 73.1156Z"
                    fill="#EE1696"
                  />
                  <path
                    d="M97.4647 70.8312L77.2599 82.4965L77.1982 83.2246L97.4647 71.5223V70.8312Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M97.4647 53.1729L77.2599 64.8382L77.1982 65.5663L97.4647 53.864V53.1729Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M35.8229 5.96289L15.8525 17.4937L16.0401 18.0774L36.4226 6.30842L35.8229 5.96289Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M91.6888 100.21V106.937L94.1075 105.541V98.8121L91.6888 100.21ZM91.3198 107.574V99.998L94.4752 98.1766V105.752L91.3198 107.574Z"
                    fill="#28285D"
                  />
                  <path
                    d="M81.1962 105.711V112.44L88.5398 108.269V101.539L81.1962 105.711ZM80.8271 113.072V105.496L80.921 105.443L88.9088 100.908V108.483L88.815 108.536L80.8271 113.072Z"
                    fill="#28285D"
                  />
                </svg>
              </div>
            </div>
            <div className="card flex-full flex-col align-end gap-56 py-40 px-24">
              <div className="textWrap flex-col gap-24">
                <div className="numberWrap">
                  <span>04</span>
                </div>
                <div className="titleWrap">
                  <span>
                    강화된 출입·보안
                    <br />
                    통제 시스템
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    RF-Key 인증, CCTV, 출입 로그 이력 관리 등 철저한 물리적 보안
                    관리 체계를 통해 고객 자산을 안전하게 보호합니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="131"
                  height="95"
                  viewBox="0 0 131 95"
                  fill="none"
                >
                  <path
                    d="M102.408 76.0722L102.415 71.5524L107.758 44.618L102.482 41.3581L91.9103 47.1964L91.836 81.9108C91.8301 84.2472 92.7041 85.8272 94.0485 86.3412V86.343L98.7504 89.3L99.3403 87.0643L100.147 82.9925C101.508 80.9867 102.402 78.4202 102.408 76.0722Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M102.382 89.1954C99.4615 90.809 97.1019 89.0075 97.1106 85.1742L97.1864 50.4583L107.757 44.6181L107.683 79.334C107.674 83.1685 105.301 87.5849 102.382 89.1954Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M130.918 25.9267C130.918 34.7371 124.736 38.3085 117.11 33.9035C109.484 29.4976 103.303 18.7839 103.303 9.97357C103.303 1.1628 109.484 -2.40804 117.11 1.99662C124.736 6.40215 130.918 17.1152 130.918 25.9267Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M127.006 34.7892L86.8233 57.8464L65.2222 25.3765L107.084 1.18681L127.006 34.7892Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M111.204 37.6925C111.204 28.6316 104.844 17.6111 97.002 13.0798C93.4363 11.0205 90.1823 10.6607 87.6886 11.726L87.6843 11.7185L87.6333 11.7448L87.5692 11.7755L87.2458 11.9344C72.4164 19.2263 56.0036 22.7123 39.4874 22.0696L34.8088 21.8874L72.9029 87.2076L74.9668 83.2184C82.4915 68.6657 93.4873 56.2054 106.972 46.9287C109.583 45.461 111.204 42.2631 111.204 37.6925Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M77.346 72.4466C77.346 55.0634 65.1486 33.9242 50.1021 25.2316C42.5992 20.8974 35.8043 20.4772 30.8781 23.3005V23.2993L30.8519 23.3153L30.814 23.3369L26.3452 25.9576L27.9067 25.6313C24.7284 28.9437 22.8582 34.1644 22.8582 40.9697C22.8582 58.3529 35.0556 79.4921 50.1021 88.1847C56.0071 91.5966 61.4722 92.5833 65.9337 91.473L65.2273 92.5167L69.3421 90.1072L69.4062 90.0708L69.5548 89.9832H69.5489C74.3702 87.0915 77.346 81.0316 77.346 72.4466Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M74.1575 74.3069C74.1575 56.9235 61.9601 35.7843 46.9151 27.0919C39.5113 22.8145 32.7993 22.351 27.8892 25.0514L27.2061 25.451C26.9716 25.5996 26.7443 25.7568 26.52 25.9191L27.9067 25.6303C24.7284 28.9427 22.8582 34.1634 22.8582 40.9687C22.8582 58.352 35.0556 79.4911 50.1021 88.1837C56.0071 91.5957 61.4722 92.5824 65.9337 91.4721L65.2899 92.4224C70.739 89.8148 74.1575 83.5096 74.1575 74.3069Z"
                    fill="white"
                  />
                  <path
                    d="M73.2549 74.8399C73.2549 92.2233 61.0575 99.2704 46.011 90.5791C30.9659 81.8854 18.7686 60.7474 18.7686 43.363C18.7686 25.9778 30.9659 18.9324 46.011 27.6249C61.0575 36.3175 73.2549 57.4567 73.2549 74.8399Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M69.9137 72.9091C69.9137 88.1603 59.2122 94.3432 46.0112 86.7159C32.8101 79.0902 22.1101 60.5438 22.1101 45.2915C22.1101 30.0391 32.8101 23.8579 46.0112 31.4847C59.2122 39.1103 69.9137 57.6568 69.9137 72.9091Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M47.1269 86.2393C33.9274 78.6137 23.2244 60.0655 23.2244 44.8144C23.2244 36.8055 26.1783 31.299 30.8919 28.979C25.5316 30.9466 22.1101 36.669 22.1101 45.2926C22.1101 60.5449 32.8101 79.0913 46.0112 86.717C52.2788 90.3402 57.9828 90.8446 62.2477 88.746C58.127 90.2587 52.8644 89.5523 47.1269 86.2393Z"
                    fill="white"
                  />
                  <mask
                    id="mask0_239_84"
                    style={{ 'mask-type': 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="22"
                    y="28"
                    width="48"
                    height="62"
                  >
                    <path
                      d="M69.912 72.9091C69.912 88.1603 59.2104 94.3432 46.0094 86.7159C32.8084 79.0902 22.1084 60.5438 22.1084 45.2915C22.1084 30.0391 32.8084 23.8579 46.0094 31.4847C59.2104 39.1103 69.912 57.6568 69.912 72.9091Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_239_84)">
                    <path
                      d="M42.4324 53.3829L77.1136 26.5521L89.7072 48.4143L49.0001 65.127L42.4324 53.3829Z"
                      fill="#D9EFFB"
                    />
                    <path
                      d="M50.7833 61.8576C50.7833 64.9034 48.6465 66.1384 46.01 64.6148C43.3736 63.0919 41.2368 59.3885 41.2368 56.3425C41.2368 53.2966 43.3736 52.0634 46.01 53.5864C48.6465 55.1093 50.7833 58.8128 50.7833 61.8576Z"
                      fill="#5F92D3"
                    />
                  </g>
                  <path
                    d="M18.7686 3.77673C20.3353 3.77673 21.7953 4.54285 22.6894 5.82244L22.8616 6.08492L36.1727 28.3104C36.5772 29.011 36.7973 29.8029 36.8123 30.6118C36.8274 31.4206 36.6369 32.2201 36.2588 32.9353C35.8806 33.6505 35.3271 34.258 34.6501 34.701C33.9731 35.1439 33.1948 35.4078 32.388 35.4679L32.0681 35.4811H5.45099C4.64338 35.472 3.85124 35.2584 3.1485 34.8603C2.44577 34.4622 1.85535 33.8925 1.43237 33.2045C1.00939 32.5165 0.767625 31.7325 0.729652 30.9257C0.69168 30.1189 0.858733 29.3157 1.21522 28.591L1.37763 28.2875L14.6821 6.07836C15.1081 5.37591 15.7079 4.7951 16.4237 4.39195C17.1395 3.9888 17.9471 3.77691 18.7686 3.77673ZM18.7686 19.0826H17.1281L16.9361 19.0941C16.5374 19.1415 16.1699 19.3335 15.9033 19.6338C15.6367 19.934 15.4894 20.3216 15.4894 20.7231C15.4894 21.1246 15.6367 21.5122 15.9033 21.8125C16.1699 22.1127 16.5374 22.3047 16.9361 22.3521L17.1281 22.3636V27.2851L17.1396 27.4771C17.1827 27.8432 17.348 28.1842 17.6088 28.4449C17.8695 28.7057 18.2105 28.8709 18.5766 28.9141L18.7686 28.9256H20.4091L20.601 28.9141C20.9672 28.8709 21.3082 28.7057 21.5689 28.4449C21.8296 28.1842 21.9949 27.8432 22.0381 27.4771L22.0496 27.2851L22.0381 27.0932C21.9989 26.7585 21.8575 26.444 21.6333 26.1924C21.409 25.9409 21.1128 25.7645 20.7848 25.6873L20.601 25.6545L20.4091 25.6446V20.7231L20.3976 20.5312C20.3544 20.165 20.1891 19.824 19.9284 19.5633C19.6677 19.3026 19.3267 19.1373 18.9605 19.0941L18.7686 19.0826ZM18.785 14.1611L18.5766 14.1726C18.1779 14.22 17.8104 14.412 17.5438 14.7123C17.2772 15.0125 17.1299 15.4001 17.1299 15.8016C17.1299 16.2031 17.2772 16.5907 17.5438 16.891C17.8104 17.1912 18.1779 17.3832 18.5766 17.4306L18.7686 17.4421L18.9769 17.4306C19.3756 17.3832 19.7431 17.1912 20.0098 16.891C20.2764 16.5907 20.4237 16.2031 20.4237 15.8016C20.4237 15.4001 20.2764 15.0125 20.0098 14.7123C19.7431 14.412 19.3756 14.22 18.9769 14.1726L18.785 14.1611Z"
                    fill="#FC6A16"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="productSection pt-96 pb-128 flex-col align-center  justify-center"
      >
        <div className="grid flex-col gap-48">
          <div className="titleWrap flex-col gap-24">
            <div className="accent flex-row gap-8">
              <span>PRODUCTS</span>
            </div>
            <div className="title">
              <span>코로케이션 상품</span>
            </div>
            <div className="description">
              <span>
                D&A클라우드에서 제공하는 저렴한 정품 상품을 이용해보세요
              </span>
            </div>
          </div>
          <div className="productsWrap flex-col gap-64">
            <div className="productListWrap flex-col gap-40">
              <div className="flex-col gap-24">
                <div className="categoryTab flex-row gap-8">
                  <div
                    onClick={(e) => {
                      setActiveProductTab('rack');
                    }}
                    className={`chipBtn flex-row justify-center align-center px-20 ${activeProductTab === 'rack' ? 'active' : ''}`}
                  >
                    <span>렉단위형</span>
                  </div>
                  <div
                    onClick={(e) => {
                      setActiveProductTab('single');
                    }}
                    className={`chipBtn flex-row justify-center align-center px-20 ${activeProductTab === 'single' ? 'active' : ''}`}
                  >
                    <span>단독서버형</span>
                  </div>
                </div>
                <div className="productsSwiperWrap">
                  <Swiper
                    onSwiper={(swiper) => (productSwiper.current = swiper)}
                    className={'productsSwiper'}
                    onSlideChange={(swiper) =>
                      setProductActiveIndex(swiper.realIndex)
                    }
                    slidesPerView={3}
                    slidesPerGroup={3}
                    touchReleaseOnEdges={false}
                    speed={500}
                    spaceBetween={16}
                    loop={false}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                      },
                      440: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                      },
                      960: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                      },
                    }}
                  >
                    {productData
                      .filter((item, i) => activeProductTab === item.cateCode)
                      .map((item, i) => {
                        return (
                          <SwiperSlide>
                            <div className="productCard flex-col gap-24 px-16 pt-20 pb-24">
                              {item.cateCode === 'rack' ? (
                                <div className="categoryChip px-16 lag flex-col justify-center align-center">
                                  <span>렉단위형</span>
                                </div>
                              ) : (
                                <div className="categoryChip px-16 single flex-col justify-center align-center">
                                  <span>단독서버형</span>
                                </div>
                              )}

                              <div className="infoWrap flex-col gap-32">
                                <div className="titleWrap flex-row align-end justify-between">
                                  <div className="textBox flex-col gap-8">
                                    <div className="main">
                                      <span>{item.name}</span>
                                    </div>
                                    <div className="description">
                                      <span>{item.description}</span>
                                    </div>
                                  </div>

                                  <div className="iconBox">
                                    <div className="badge oneU flex-col align-center justify-center">
                                      <span>{item.caption}</span>
                                    </div>
                                    <div className="iconWrap">
                                      {item.caption === '1/2' ? (
                                        <Rack2 />
                                      ) : item.caption === '1/4' ? (
                                        <Rack1 />
                                      ) : item.caption === 'full' ? (
                                        <Rack3 />
                                      ) : item.caption === '1U' ? (
                                        <Single1 />
                                      ) : item.caption === '2U' ? (
                                        <Single2 />
                                      ) : (
                                        item.caption === '4U' && <Single3 />
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="detailInfoWrap flex-col gap-32">
                                  <div className="basicInfoWrap pt-20 flex-col gap-16">
                                    {item.char.map((charItem, i) => {
                                      return (
                                        <div className="basicInfo gap-8 flex-row">
                                          <div className="label">
                                            <span>{charItem}</span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <Link to={'/contact'}>
                                    <div className="contactBtnWrap flex-row gap-8 justify-center align-center">
                                      <div className="btnText">
                                        <span>문의하기</span>
                                      </div>

                                      <div className="iconWrap flex-row align-center justify-center">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="25"
                                          height="25"
                                          viewBox="0 0 25 25"
                                          fill="none"
                                        >
                                          <path
                                            d="M3.01758 12.686C3.01758 13.8679 3.25037 15.0383 3.70266 16.1302C4.15495 17.2221 4.81789 18.2143 5.65362 19.05C6.48934 19.8857 7.4815 20.5487 8.57343 21.001C9.66536 21.4532 10.8357 21.686 12.0176 21.686C13.1995 21.686 14.3698 21.4532 15.4617 21.001C16.5537 20.5487 17.5458 19.8857 18.3815 19.05C19.2173 18.2143 19.8802 17.2221 20.3325 16.1302C20.7848 15.0383 21.0176 13.8679 21.0176 12.686C21.0176 10.2991 20.0694 8.0099 18.3815 6.32207C16.6937 4.63425 14.4045 3.68604 12.0176 3.68604C9.63063 3.68604 7.34144 4.63425 5.65362 6.32207C3.96579 8.0099 3.01758 10.2991 3.01758 12.686Z"
                                            fill="#1681FC"
                                            className={
                                              'iconColorChangePoint background'
                                            }
                                          />
                                          <path
                                            d="M9.01758 12.686H15.0176"
                                            className={
                                              'iconColorChangePoint obj'
                                            }
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M12.0176 9.68604V15.686"
                                            className={
                                              'iconColorChangePoint obj'
                                            }
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                  </Swiper>
                </div>
              </div>
              <div className="indicaterGageWrap flex-col justify-center  ">
                <div className="gird flex-col">
                  <div
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                    className="gageRail"
                    onClick={handleClick} // 클릭 이벤트 추가
                  >
                    <div
                      style={{
                        maxWidth: progressPercent + '%',
                      }}
                      className="gage"
                    ></div>
                    {tooltipVisible && (
                      <div
                        className="tooltip"
                        style={{
                          left: `${tooltipPercent}%`,
                        }}
                      >
                        {Math.round(tooltipPercent)}%
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="moreProductBannerWrap obj py-40 flex-row gap-24 align-start px-40 justify-between">
              <div className="textWrap flex-col gap-16 align-start">
                <div className="title">
                  <span>지금 문의 시 서버 이전 및 초기 설치 지원 </span>
                </div>
                <BlackArrowBtn to={'/contact'} text={'컨설팅 신청'} />
              </div>
              <div className="imgWrap flex-row align-center justify-center">
                <img src={productBannerForCorocation} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="serviceSection  flex-col justify-center align-center"
      >
        <div className="grid flex-col gap-48">
          <div className="titleWrap flex-col gap-24">
            <div className="accent flex-row gap-8">
              <span>SERVICE</span>
            </div>
            <div className="title">
              <span>부가 서비스</span>
            </div>
            <div className="description">
              <span>최고의 사용경험을 위해 제공되는 부가 서비스입니다</span>
            </div>
          </div>
          <div className="contentWrap flex-row ">
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(1);
              }}
              className={`hoverCard flex-col pr-16 gap-16 ${portfolioActiveIndex === 1 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="serviceTextWrap py-96  px-40 flex-col gap-16">
                  <div className="main">
                    <span>매니지드 서비스</span>
                  </div>
                  <div className="sub">
                    <span>
                      - 전문 엔지니어가 서버 운영을 대신 관리해드립니다.
                      <br />- 보안 패치, 트래픽 분석, 장애 대응까지 통합
                      지원하여, <br />
                      기술 인력 없이도 안정적인 서버 운영이 가능합니다.
                    </span>
                  </div>
                </div>
                <div className="mainImgWrap">
                  <img src={portfolioImg1} alt="" />
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>01</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(2);
              }}
              className={`hoverCard flex-col pr-16 gap-16 ${portfolioActiveIndex === 2 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="serviceTextWrap py-96  px-40 flex-col gap-16">
                  <div className="main">
                    <span>백업 & 복구 서비스</span>
                  </div>
                  <div className="sub">
                    <span>
                      - 정기 백업과 긴급 복구 시스템으로 데이터 손실 걱정 없이
                      운영하세요.
                      <br />- RAID 구성, 원격 백업, 주기적 점검으로 중단 없는
                      서비스 연속성을 보장합니다.
                    </span>
                  </div>
                </div>
                <div className="mainImgWrap">
                  <img src={portfolioImg2} alt="" />
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>02</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(3);
              }}
              className={`hoverCard flex-col  gap-16 ${portfolioActiveIndex === 3 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="serviceTextWrap py-96  px-40 flex-col gap-16">
                  <div className="main">
                    <span>원격 핸즈 (Remote Hands)</span>
                  </div>
                  <div className="sub">
                    <span>
                      - 현장 방문 없이 장비 조작, 재부팅, 상태 점검 요청이
                      가능합니다.
                      <br />- 디엔에이클라우드 현장 엔지니어가 대신
                      작업해드립니다 <br />— 빠르고 안전하게!
                    </span>
                  </div>
                </div>
                <div className="mainImgWrap">
                  <img src={portfolioImg3} alt="" />
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>03</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="faqSection py-128 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-48">
          <div className="titleWrap flex-col gap-24">
            <div className="accent flex-row gap-8">
              <span>FAQ</span>
            </div>
            <div className="title">
              <span>자주 묻는 질문</span>
            </div>
            <div className="description">
              <span>코로케이션에 대해 좀 더 궁금하신가요?</span>
            </div>
          </div>
          <div className="faqListWrap">
            {qnaData?.map((item, i) => {
              return (
                <div
                  onClick={() =>
                    setActiveFaqTab(activeFaqTab === i + 1 ? 0 : i + 1)
                  }
                  className="faqItem flex-col gap-8 py-24"
                >
                  <div className="faqQ px-16  flex-row gap-16 justify-between">
                    <div className="flex-col gap-16">
                      <div className="label">
                        <span>Q</span>
                      </div>
                      <div className="title">
                        <span>{item?.q}</span>
                      </div>
                    </div>
                    <div
                      className={`iconWrap flex-col justify-center align-center icon-24 ${activeFaqTab === i + 1 ? 'active' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="9"
                        viewBox="0 0 14 9"
                        fill="none"
                      >
                        <path
                          d="M1.08008 7.68677L7.01758 1.83495L12.9551 7.68677"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    className={`faqA flex-col px-16 ${activeFaqTab === i + 1 ? 'active py-16' : ''}`}
                  >
                    <div className="content">
                      <span>{item?.a}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="ctaBanner pb-128 flex-col justify-center align-center"
      >
        <div className="grid py-40 tab:py-20 mob:py-32">
          <div className="bannerImage">
            <img src={bannerImg} alt="" />
          </div>
          <div className="titleWrap px-40 flex-col gap-48 tab:px-20 mob:px-16">
            <div className="flex-col gap-16">
              <div className="main">
                <span>최고의 파트너를 찾으시나요?</span>
              </div>
              <div className="description">
                <span>
                  디앤에이클라우드의 전문가들과 함께
                  <br />
                  최적의 인프라를 통해 비즈니스를 확장하세요
                </span>
              </div>
            </div>
            <Link to={'/contact'}>
              <div className="primaryBtn44">
                <span>문의하기</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CorocationMain;
